import { createFileRoute, redirect } from '@tanstack/react-router';

import { ImportAuditLogPage } from '~pages/import-wizard/import-audit-log-page';
import { UserRoles } from '~entities/users';
import { checkMinRoleValue } from '~shared/utils/role-guard';

const PendingComponent = () => (
  <div className='flex h-screen items-center justify-center'>Loading…</div>
);

export const Route = createFileRoute(
  '/_auth/_layout/_settings/import-data-logs',
)({
  beforeLoad: async () => {
    const hasAccess = await checkMinRoleValue(UserRoles.ADMIN);
    if (!hasAccess) {
      return redirect({ to: '/dashboard' });
    }
  },
  pendingComponent: PendingComponent,
  component: ImportAuditLogPage,
});
